'use client'
import React from 'react';
import styles from './loader.module.scss';

interface LoaderProps {
    loading: boolean;
    useFullWindow?: boolean;
    useNoBackground?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ loading, useFullWindow = false, useNoBackground = false }) => {
    if (!loading) return null;

    return (
        <div className={`${useFullWindow ? styles.backdropFullWindow : (useNoBackground ? styles.noBackdrop : styles.backdrop)} ${!useNoBackground ? "bg-gs-backdrop" : ""}`}>
            <div className={`loader loader-color`}></div>
        </div>
    );
};

export default Loader;